"use strict";

import http from "@/http";

const BASE_NAME = "/sent-emails";

// Devuelve { items, total, page, limit }. El total es el de la consulta ya
// filtrada, que es lo que necesita el footer de la tabla.
const getEmails = async ({ page = 1, limit = 15, search = null } = {}) => {
  const params = { page, limit };
  if (search) {
    params.search = search;
  }
  let response = await http.get(`${BASE_NAME}`, { params });
  return response.data;
};

export default {
  getEmails
};
